// SGK İşe Giriş: bildirgedeki sicil son 4 hane, SGK Hizmet Listesi sicili ile karşılaştırılır
import { useState } from 'react';
import { CheckCircle2 } from 'lucide-react';

export const sicilBlockReason = (refSicil, value) => (
  !refSicil ? "Önce firma belgelerinde SGK Hizmet Listesi'ni onaylayın, sicil girin"
    : !/^\d{4}$/.test(value || '') ? 'SGK sicil numarasının son 4 hanesini girin'
    : value !== refSicil ? 'Sicil eşleşmiyor: bildirge bu işyerine ait değil'
    : null
);

export const SicilMatchBox = ({ refSicil, savedSicil, approved, value, onChange, onSave }) => {
  const [edit, setEdit] = useState(false);
  const showSaved = approved && savedSicil && !edit;
  const shown = showSaved ? savedSicil : value;
  const valid = /^\d{4}$/.test(shown || '');
  return (
    <div className="space-y-1.5 rounded-lg border border-sky-200 bg-sky-50/50 p-3 text-xs" data-testid="sgk-ise-giris-sicil-box">
      <p className="font-medium text-slate-700">SGK Sicil No Kontrolü (son 4 hane)</p>
      <div className="flex justify-between"><span className="text-slate-600">SGK Hizmet Listesi:</span><span className="font-mono font-bold text-slate-800" data-testid="sgk-ise-giris-ref-sicil">{refSicil || '—'}</span></div>
      {showSaved ? (
        <div className="flex items-center justify-between" data-testid="sgk-ise-giris-sicil-saved">
          <span className="flex items-center gap-1.5 font-semibold text-emerald-700"><CheckCircle2 className="h-4 w-4" />İşe Giriş Bildirgesi (kayıtlı):</span>
          <span className="flex items-center gap-1"><span className="font-mono text-sm font-bold tracking-widest text-slate-800">{savedSicil}</span>
            <button type="button" onClick={() => { onChange(savedSicil); setEdit(true); }} className="rounded px-1.5 py-0.5 text-sky-700 hover:bg-sky-100" data-testid="sgk-ise-giris-sicil-edit">Değiştir</button></span>
        </div>
      ) : (
        <div className="space-y-1">
          <label className="text-slate-500">İşe Giriş Bildirgesindeki SGK Sicil No (son 4 hane) *</label>
          <div className="flex items-center gap-2">
            <input value={value} onChange={(e) => onChange(e.target.value.replace(/\D/g, '').slice(0, 4))} inputMode="numeric" placeholder="1234"
              className="h-8 w-24 rounded-md border border-slate-200 bg-white px-2 text-center font-mono text-sm tracking-widest" data-testid="sgk-ise-giris-sicil-input" />
            {approved && (
              <button type="button" disabled={!valid || !refSicil} onClick={() => { onSave(value); setEdit(false); }}
                className="h-8 rounded-md bg-sky-600 px-3 text-xs font-medium text-white hover:bg-sky-700 disabled:opacity-40" data-testid="sgk-ise-giris-sicil-save">Sicili Kaydet</button>
            )}
          </div>
        </div>
      )}
      {!refSicil
        ? <p className="rounded border-2 border-rose-400 bg-rose-50 px-2 py-1 font-semibold text-rose-700" data-testid="sgk-ise-giris-sicil-missing">Önce firma belgelerinde SGK Hizmet Listesi'ni onaylayın, sicil girin.</p>
        : valid && (shown === refSicil
          ? <p className="rounded border border-emerald-300 bg-emerald-50 px-2 py-1 font-semibold text-emerald-700" data-testid="sgk-ise-giris-sicil-ok">Sicil eşleşti: bildirge bu işyerine aittir</p>
          : <p className="rounded border-2 border-rose-400 bg-rose-50 px-2 py-1 font-semibold text-rose-700" data-testid="sgk-ise-giris-sicil-mismatch">Sicil eşleşmiyor! Bildirge bu işyerine ait değil.{approved ? '' : ' Onay verilemez.'}</p>)}
    </div>
  );
};
